import type { Project, DiversSubProject } from '../../types';
import { formatDiversLabel } from '../../utils/diversDisplayUtils';

interface ProjectSelectorProps {
  projects: Project[];
  diversSubProjects: DiversSubProject[];
  selectedProjectId: string;
  isLocked: boolean;
  onSelectChange: (value: string) => void;
  onAdd: () => void;
}

export function ProjectSelector({ projects, diversSubProjects, selectedProjectId, isLocked, onSelectChange, onAdd }: ProjectSelectorProps) {
  if (isLocked) return null;

  return (
    <div style={{ marginBottom: '30px', display: 'flex', gap: '16px' }}>
      <select value={selectedProjectId} onChange={(e) => onSelectChange(e.target.value)} style={{ flex: 1, padding: '16px', fontSize: '1.1rem', borderRadius: '14px', border: '1px solid #cbd5e1', backgroundColor: 'white', color:'#1e293b' }}>
        <option value="">-- Ajouter un chantier --</option>
        {/* Projets Production (hors SYS-FORM et catégorie divers) */}
        {projects.filter(p => p.code !== 'SYS-FORM' && p.category !== 'divers').map(p => (
          <option key={p.id} value={p.id}>{p.code} - {p.name}</option>
        ))}
        {/* Sous-chantiers Divers avec leurs vrais noms */}
        {diversSubProjects.length > 0 && (
          <optgroup label="── Affaires Diverses ──">
            {diversSubProjects.map(sub => {
              const parentProject = projects.find(p => p.id === sub.parent_project_id);
              return (
                <option key={`sub-${sub.id}`} value={`sub:${sub.id}`}>
                  {formatDiversLabel(parentProject?.code ?? '???', sub.name)}
                </option>
              );
            })}
          </optgroup>
        )}
      </select>
      <button onClick={onAdd} style={{ padding: '0 32px', background: '#2563eb', color: 'white', border: 'none', borderRadius: '14px', fontSize: '1.8rem', cursor: 'pointer', boxShadow: '0 4px 6px rgba(37,99,235,0.2)' }}>+</button>
    </div>
  );
}
